import { CalendarIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';
import type { JobVisitWithCrewDto, PaymentMethod } from '@/lib/api/jobs';

import { VisitRow } from './visit-row';

interface Props {
  visits: JobVisitWithCrewDto[];
  businessId: string;
  jobId: string;
  jobTitle: string;
  jobDefaultPaymentMethod?: PaymentMethod | null;
  jobDefaultPaymentMethodId?: string | null;
}

export function VisitTable({
  visits,
  businessId,
  jobId,
  jobTitle,
  jobDefaultPaymentMethod,
  jobDefaultPaymentMethodId,
}: Props) {
  const { t } = useLanguage();

  if (visits.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 gap-2 text-center border rounded-xl bg-card">
        <CalendarIcon className="w-9 h-9 text-muted-foreground/40" />
        <p className="text-sm text-muted-foreground">{t.seriesNoOccurrences}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3" data-testid="occurrence-table">
      <div className="hidden sm:flex flex-wrap items-center gap-x-4 gap-y-1 px-3 text-[11px] font-medium uppercase text-muted-foreground">
        <span className="w-28">{t.seriesColDate}</span>
        <span>{t.seriesColStatus}</span>
        <span>{t.seriesColPayment}</span>
        <span className="flex-1">{t.seriesColCrew}</span>
        <span className="w-20 text-right">{t.seriesColBilled}</span>
        <span className="w-20 text-right">{t.seriesColCollected}</span>
      </div>
      <ul className="flex flex-col gap-2">
        {visits.map((visit) => (
          <VisitRow
            key={visit.id}
            visit={visit}
            businessId={businessId}
            jobId={jobId}
            jobTitle={jobTitle}
            jobDefaultPaymentMethod={jobDefaultPaymentMethod}
            jobDefaultPaymentMethodId={jobDefaultPaymentMethodId}
          />
        ))}
      </ul>
    </div>
  );
}
